import { createFileRoute, redirect } from "@tanstack/react-router";
import Layout from "../../components/Layout";
import { AuthUnavailableError } from "@/features/auth/authErrors";
import { sanitizeAuthRedirect } from "@/features/auth/sanitizeAuthRedirect";

export const Route = createFileRoute("/_authed")({
  beforeLoad: async ({ context, location }) => {
    const auth = await context.auth.initialize();
    if (auth.status === "unauthenticated") {
      throw redirect({
        to: "/login",
        search: { redirect: sanitizeAuthRedirect(location.href) },
      });
    }
    if (auth.status === "unavailable") {
      throw new AuthUnavailableError();
    }
  },
  component: () => <Layout />,
});
